import React from 'react'

import { useAuthState } from 'hooks'

import PaymentCheck from './PaymentCheck'

const AppChecks = () => {
  const auth = useAuthState()
  if (!auth?.user || auth.user) {
    return null
  }

  return (
    <>
      <PaymentCheck user={auth.user} />
    </>
  )
}

export default AppChecks
